import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=9705b04c&scoped=true&"
import script from "./OrderModal.vue?vue&type=script&lang=ts&"
export * from "./OrderModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=9705b04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9705b04c",
  null
  
)

export default component.exports